import React from 'react';
import { NavLink } from 'react-router-dom';
import { TEMA } from '../theme';
import { useAuth } from '../context/AuthContext';

// Flikarna högst upp på Inställningar. Sidorna är separata men ska upplevas
// som en. Händelseloggen gäller hela appen och visas bara för admin.
const FLIKAR = [
  { till: '/profil', text: 'Min profil', baraAdmin: false },
  { till: '/admin', text: 'Användare', baraAdmin: false },
  { till: '/handelselogg', text: 'Händelselogg', baraAdmin: true },
];

export default function InstallningarFlikar() {
  const { profil } = useAuth();
  const flikar = FLIKAR.filter(f => !f.baraAdmin || profil?.roll === 'admin');
  return (
    <div style={{ display: 'flex', gap: '24px', borderBottom: `1px solid ${TEMA.border}`, marginBottom: '24px' }}>
      {flikar.map(f => (
        <NavLink
          key={f.till}
          to={f.till}
          style={({ isActive }) => ({
            padding: '0 0 10px', textDecoration: 'none', marginBottom: '-1px',
            fontFamily: "'Inter', sans-serif", fontSize: '14px',
            color: isActive ? TEMA.ink : TEMA.inkFaint,
            borderBottom: `2px solid ${isActive ? TEMA.accent : 'transparent'}`,
          })}
        >
          {f.text}
        </NavLink>
      ))}
    </div>
  );
}
